import axios from "axios";
import { SETTINGS } from "../../Settings";

export const UserRepository = {
  getCurrentUser: () => {
    return axios({
      url: `${SETTINGS.EXTERNAL_API_URL}external/users/current`,
      method: "GET",
    });
  },

  registerUser: (data) => {
    return axios({
      url: `${SETTINGS.EXTERNAL_API_URL}registration`,
      method: "POST",
      data,
    });
  },

  confirmRegistration: (token) => {
    return axios({
      url: `${SETTINGS.EXTERNAL_API_URL}registration/confirmation/${token}`,
      method: "POST",
    });
  },
};
